import { Link } from 'react-router-dom';
import { featuredComics } from '@/mocks/comics';

export default function HeroSection() {
  return (
    <section className="relative h-[420px] md:h-[600px] w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20art%20collage%20panoramic%20banner%20featuring%20multiple%20characters%20from%20romance%20action%20fantasy%20genres%20artistic%20illustration%20style%20warm%20vibrant%20colors%20soft%20gradient%20atmosphere%20cinematic%20composition%20clean%20professional%20artwork%20digital%20painting%20style%20with%20dramatic%20lighting&width=1920&height=1080&seq=hero-bg-hanman&orientation=landscape"
          alt="韩漫之家 - 最新高清免费韩国漫画大全"
          className="w-full h-full object-cover object-top"
          title="韩漫之家 - 最新高清免费韩国漫画大全"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 h-full flex flex-col justify-center items-start px-4 md:px-6">
        <div className="max-w-7xl mx-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div className="flex flex-col gap-6">
            <div className="flex items-center gap-2">
              <div className="flex -space-x-2">
                <div className="w-9 h-9 rounded-full border-2 border-white overflow-hidden bg-background-200">
                  <img
                    src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20character%20chibi%20portrait%20cute%20minimalist%20style%20simple%20background%20clean%20illustration%20kawaii&width=72&height=72&seq=avatar-1-hero&orientation=squarish"
                    alt="读者头像"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="w-9 h-9 rounded-full border-2 border-white overflow-hidden bg-background-200">
                  <img
                    src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20character%20chibi%20female%20portrait%20cute%20minimalist%20style%20simple%20background%20clean%20illustration%20kawaii&width=72&height=72&seq=avatar-2-hero&orientation=squarish"
                    alt="读者头像"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="w-9 h-9 rounded-full border-2 border-white overflow-hidden bg-background-200">
                  <img
                    src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20character%20chibi%20male%20portrait%20cute%20minimalist%20style%20simple%20background%20clean%20illustration%20kawaii&width=72&height=72&seq=avatar-3-hero&orientation=squarish"
                    alt="读者头像"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <span className="text-white/90 text-sm">已有超过 200万+ 读者加入</span>
            </div>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
              最新高清免费<br />
              <span className="font-light">韩国漫画大全</span>
            </h1>
            <p className="text-white/80 text-lg md:text-xl max-w-md leading-relaxed">
              热门韩漫在线阅读，每日更新最新章节。为您精选最优质的韩国漫画作品。
            </p>
            <div className="flex items-center gap-3">
              <Link
                to="/category/action"
                className="bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium px-6 py-3 rounded-md whitespace-nowrap cursor-pointer transition-colors inline-flex items-center gap-2"
              >
                立即阅读
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
              <Link
                to="/about"
                className="border border-white/40 text-white hover:bg-white/10 text-sm font-medium px-6 py-3 rounded-md whitespace-nowrap cursor-pointer transition-colors"
              >
                了解更多
              </Link>
            </div>
          </div>

          <div className="hidden lg:flex items-end justify-end">
            <div className="relative">
              <div className="flex gap-3">
                {featuredComics.slice(0, 3).map((comic, idx) => (
                  <Link
                    key={comic.id}
                    to={`/comic/${comic.slug}`}
                    className={`relative rounded-lg overflow-hidden cursor-pointer transition-transform hover:scale-105 ${
                      idx === 1 ? 'w-36 h-52 -mt-8' : 'w-28 h-44'
                    }`}
                  >
                    <img
                      src={comic.coverImage}
                      alt={comic.title}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
                    <div className="absolute bottom-2 left-2 right-2">
                      <p className="text-white text-xs font-medium truncate">{comic.title}</p>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}